module.exports = __webpack_public_path__ + "img/icon-facebook-new.02f638d0.svg";